import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingDotsComponent } from './LoadingDots.component';

export const LoadingDotsModuleExports = [LoadingDotsComponent];

@NgModule({
    imports: [CommonModule],
    declarations: [...LoadingDotsModuleExports],
    exports: [...LoadingDotsModuleExports],
    providers: []
})
export class LoadingDotsModule {}
